import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { ApiParameter, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { DataViewState, setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { BackOrderCollectionModel, BackOrderModel } from "@rc/App/Services/BackOrder/BackOrderService";
import { GetBackOrderApiParameter } from "@rc/App/Store/Reducers/xBackOrderListReducer";
import { Draft } from "immer";

function storeIdByOrderSku(draft: Draft<BackOrdersState>, backOrder: BackOrderModel) {
    draft.idByOrderSku[backOrder.sku] = backOrder.id;
}

export interface BackOrdersState extends DataViewState<BackOrderModel> {
    readonly idByOrderSku: Dictionary<string>;
    failedToLoadBackOrders?: boolean;
}

const initialState: BackOrdersState = {
    isLoading: {},
    byId: {},
    idByOrderSku: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const reducer = {
    "Data/BackOrders/BeginLoadBackOrders": (
        draft: Draft<BackOrdersState>,
        action: { parameter: GetBackOrderApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/BackOrders/CompleteLoadBackOrders": (
        draft: Draft<BackOrdersState>,
        action: { parameter: GetBackOrderApiParameter; collection: BackOrderCollectionModel },
    ) => {
        action.collection?.backOrders?.forEach(order => {
            order.timeFrameAvailability = action.collection?.timeFrameAvailability;
        });
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => collection.backOrders!,
            order => storeIdByOrderSku(draft, order),
        );

        if (draft.failedToLoadBackOrders) {
            draft.failedToLoadBackOrders = false;
        }
    },

    "Data/BackOrders/FailedToLoadBackOrders": (draft: Draft<BackOrdersState>) => {
        draft.failedToLoadBackOrders = true;
    },

    "Data/BackOrders/Reset": () => {
        return initialState;
    },
};

const xBackOrdersState = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xBackOrdersState = xBackOrdersState;

export type xBackOrdersState = {
    xBackOrdersState: BackOrdersState;
};

type xBackOrdersStateReducers = {
};

export type xBackOrdersStateActions = Parameters<xBackOrdersStateReducers[keyof xBackOrdersStateReducers]>[1] | AnyAction;
